export default __webpack_public_path__ + "static/media/horizonMobile.0eef93dc.png";